import React, { memo } from 'react'
import styled from '@emotion/styled'
import { useTheme } from 'emotion-theming'
import { string, number } from 'prop-types'

const Svg = styled.svg`
	&:hover {
		circle,
		g {
			fill: ${({ hoverBackgroundColor }) => (hoverBackgroundColor ? hoverBackgroundColor : 'transparent')};
		}
		path {
			fill: ${({ hoverColor }) => hoverColor};
			stroke: ${({ hoverColor }) => hoverColor};
		}
	}
`

export const Pinterest = memo(({ height = 30, variant = 'primary', width = 30 }) => {
	const {
		colors,
		socialProfileSvgs: { inverse, neutral, primary },
	} = useTheme()
	let backgroundColor = 'transparent'
	let fillColor = colors.secondary
	let hoverBackgroundColor = 'transparent'
	let hoverColor = colors.tertiary

	switch (variant) {
		case 'neutral':
			backgroundColor = neutral.backgroundColor
			fillColor = neutral.fillColor
			hoverBackgroundColor = neutral.hoverBackgroundColor
			hoverColor = neutral.hoverFillColor
			break
		case 'inverse':
			fillColor = inverse.fillColor
			hoverColor = inverse.hoverFillColor
			break
		case 'primary':
		default:
			fillColor = primary.fillColor
			hoverColor = primary.hoverFillColor
			break
	}
	return (
		<Svg
			height={height}
			width={width}
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			viewBox="1 1 34 34"
			style={{ enableBackground: 'new 1 1 34 34' }}
			xmlSpace="preserve"
			hoverColor={hoverColor}
			hoverBackgroundColor={hoverBackgroundColor}
		>
			<circle id="top" cx={18} cy={18} r={18} fill={backgroundColor} />
			<g fill={fillColor} fillRule="evenodd">
				<path
					d="M17.848 34.826A16.814 16.814 0 011 17.978 16.814 16.814 0 0117.848 1.13a16.814 16.814 0 0116.848 16.848c0 9.201-7.517 16.718-16.848 16.848zm0-32.53c-8.554 0-15.552 6.998-15.552 15.552 0 8.554 6.998 15.552 15.552 15.552 8.554 0 15.552-6.998 15.552-15.552 0-8.554-6.998-15.552-15.552-15.552z"
					stroke={fillColor}
					strokeWidth={0.72}
					fillRule="nonzero"
				/>
				<path d="M17.996 9A8.992 8.992 0 009 17.996a9 9 0 005.716 8.382c-.081-.71-.148-1.807.03-2.584.163-.704 1.051-4.472 1.051-4.472s-.266-.54-.266-1.333c0-1.251.725-2.184 1.629-2.184.77 0 1.14.577 1.14 1.266 0 .77-.489 1.925-.748 2.999-.215.895.452 1.628 1.333 1.628 1.6 0 2.828-1.688 2.828-4.116 0-2.155-1.547-3.658-3.761-3.658-2.562 0-4.065 1.918-4.065 3.902 0 .77.296 1.6.666 2.051.074.089.082.17.06.26-.067.28-.223.895-.252 1.021-.037.163-.134.2-.304.118-1.11-.533-1.806-2.176-1.806-3.494 0-2.836 2.058-5.443 5.945-5.443 3.117 0 5.546 2.222 5.546 5.198 0 3.103-1.955 5.598-4.665 5.598-.91 0-1.77-.474-2.058-1.037l-.563 2.14c-.2.785-.748 1.762-1.118 2.362.844.26 1.733.4 2.666.4A8.997 8.997 0 0027 18.004C26.993 13.028 22.965 9 17.996 9z" />
			</g>
		</Svg>
	)
})
Pinterest.propTypes = {
	color: string,
	height: number,
	width: number,
}
